import { FolderOutlined } from "@mui/icons-material"
import { List, ListItem, ListItemButton, Typography } from "@mui/material"
import { SimpleTreeView, TreeItem } from "@mui/x-tree-view"
import { ExplorableFile } from "../root.component"
import { useState } from "react"

export const Sidebar = (props: any) => {

    const [selectedItems, setSelectedItems] = useState<string[]>([]);

    const renderItem = (file: ExplorableFile) => {
        return (
            <TreeItem
                onDoubleClick={(e) => {
                    e.stopPropagation();

                    props.onNavigate?.('/' + file.path)
                }}
                key={`sidebar-${file.path}`} 
                itemId={file.path}
                label={<div style={{display: 'flex'}}>
                    <FolderOutlined /><Typography sx={{marginLeft: '8px'}}>{file.name}</Typography>
                </div>}>
                {file.children?.map(renderItem)}
            </TreeItem>
        )
    }
    return (
        <SimpleTreeView
            >
            {props.files?.map((file) => renderItem(file)
       
            //     dense
            //     key={`sidebar-${file.path}`} disablePadding>
            //     <ListItemButton>
            //       <FolderOutlined />
            //       <Typography sx={{marginLeft: '8px'}}>
            //         {file.name}
            //       </Typography>
            //     </ListItemButton>
            //   </ListItem>
            )}
          </SimpleTreeView>
    )
}